import { ObjectsStates, TransitionArgs } from './types/animations';
import { toRadians as r } from './utils';
import { getTransition as t } from './utils/transition';
import { AnimationEvent } from './types/animations';

export namespace HomeExperiences {

    export enum Objects {
        Root = 'Scene_0',

        Music = 'Music_promotions_2',
        Music_float = 'music_float',
        Music_bar1 = 'bar_1',
        Music_bar2 = 'bar_2',

        Curator = 'Curator_network_2',

        Quality = 'Quality_-_selection_of_playlists_2',
        Quality_glass = 'glass',
        Quality_diamond = 'diamond',
        Quality_icons1 = '14_list_icon_2',
        Quality_icons2 = '14_list_icon_2_1',

        Optimize = 'Optimize_campaigns_-_boost_2',
        Support = 'support_2',
        Dashboard = 'dashboard_2',
    }

    export namespace States {

        export namespace Root {
            export const root_float = {
                name: Objects.Root,
                states: {
                    'Base State': {
                        position: [0, 0, 0],
                    },
                    State: {
                        position: [-0.01, 0.03, 0],
                    },
                },
            } as const satisfies ObjectsStates;

            export const root_rotate = {
                name: Objects.Root,
                states: {
                    'Base State': {
                        rotation: [-Math.PI, r(0), -Math.PI],
                    },
                    State: {
                        rotation: [-Math.PI, r(180), -Math.PI],
                    },
                    'State 2': {
                        rotation: [-Math.PI, r(360), -Math.PI],
                    },
                    'State 3': {
                        rotation: [-Math.PI, r(540), -Math.PI],
                    },
                    'State 4': {
                        rotation: [-Math.PI, r(720), -Math.PI],
                    },
                    'State 5': {
                        rotation: [-Math.PI, r(900), -Math.PI],
                    },
                },
            } as const satisfies ObjectsStates;
        }

        export namespace Music {
            export const root = {
                name: Objects.Music,
                states: {
                    'Base State': {
                        position: [0, 0, 0],
                        scale: [1, 1, 1],
                    },
                    State: {
                        position: [0, 0, 0.1],
                        scale: [0, 0, 0],
                    },
                },
            } as const satisfies ObjectsStates;

            export const float = {
                name: Objects.Music_float,
                states: {
                    'Base State': {
                        rotation: [0, 0, 0],
                    },
                    State: {
                        rotation: [r(22.58), r(7.95), 0],
                    },
                },
            } as const satisfies ObjectsStates;

            export const bar1 = {
                name: Objects.Music_bar1,
                states: {
                    'Base State': {
                        position: [0.09, 0.01, 0],
                        rotation: [r(-90), 0, r(-180)],
                    },
                    State: {
                        position: [0.11, 0.01, 0],
                        rotation: [r(-80), 0, r(-180)],
                    },
                },
            } as const satisfies ObjectsStates;

            export const bar2 = {
                name: Objects.Music_bar2,
                states: {
                    'Base State': {
                        position: [0.13, 0.01, 0],
                        rotation: [r(-90), 0, r(-180)],
                    },
                    State: {
                        position: [0.17, 0.01, 0],
                        rotation: [r(-80), 0, r(-180)],
                    },
                },
            } as const satisfies ObjectsStates;
        }

        export namespace Curator {
            export const root = {
                name: Objects.Curator,
                states: {
                    'Base State': {
                        scale: [0, 0, 0],
                    },
                    State: {
                        scale: [1, 1, 1],
                    },
                },
            } as const satisfies ObjectsStates;
        }

        export namespace Quality {
            export const root = {
                name: Objects.Quality,
                states: {
                    'Base State': {
                        scale: [0, 0, 0],
                    },
                    State: {
                        scale: [1, 1, 1],
                    },
                },
            } as const satisfies ObjectsStates;

            export const glass = {
                name: Objects.Quality_glass,
                states: {
                    'Base State': {
                        rotation: [r(11.64), r(10.49), r(12.35)],
                    },
                    State: {
                        rotation: [r(-3.38), r(31.18), r(17.82)],
                    },
                },
            } as const satisfies ObjectsStates;

            export const diamond = {
                name: Objects.Quality_diamond,
                states: {
                    'Base State': {
                        position: [0.08, 0.16, 0.12],
                        rotation: [r(3.64), r(-18.03), r(-21.11)],
                    },
                    State: {
                        position: [0.09, 0.17, 0.13],
                        rotation: [r(-5.13), r(-44.49), r(-26.73)],
                    },
                },
            } as const satisfies ObjectsStates;

            export const icons1 = {
                name: Objects.Quality_icons1,
                states: {
                    'Base State': {
                        rotation: [r(-167.24), r(-0.22), r(172.64)],
                    },
                    State: {
                        rotation: [r(-167.24), r(-0.22), r(179.46)],
                    },
                },
            } as const satisfies ObjectsStates;

            export const icons2 = {
                name: Objects.Quality_icons2,
                states: {
                    'Base State': {
                        position: [-0.02, 0.07, 0.09],
                        rotation: [r(178.87), r(-0.22), r(152.21)],
                    },
                    State: {
                        position: [-0.01, 0.09, 0.09],
                        rotation: [r(178.87), r(-0.22), r(160.18)],
                    },
                },
            } as const satisfies ObjectsStates;
        }

        export namespace Optimize {
            export const root = {
                name: Objects.Optimize,
                states: {
                    'Base State': {
                        scale: [0, 0, 0],
                    },
                    State: {
                        scale: [1, 1, 1],
                    },
                },
            } as const satisfies ObjectsStates;
        }

        export namespace Support {
            export const root = {
                name: Objects.Support,
                states: {
                    'Base State': {
                        scale: [0, 0, 0],
                        rotation: [0, 0, 0],
                    },
                    State: {
                        scale: [1, 1, 1],
                        rotation: [r(10), r(-30), 0],
                    },
                },
            } as const satisfies ObjectsStates;
        }

        export namespace Dashboard {
            export const root = {
                name: Objects.Dashboard,
                states: {
                    'Base State': {
                        scale: [0, 0, 0],
                    },
                    State: {
                        scale: [1, 1, 1],
                    },
                },
            } as const satisfies ObjectsStates;
        }
    }

    export namespace Events {

        const st = (duration: number, position: number = 0, reset = false) => ({
            easing: 'none',
            reset: reset,
            duration,
            position,
        } as const satisfies TransitionArgs);

        const generalDuration = 100;
        const pauseDuration = 3;
        const countOfScenes = 5;

        const durationWithoutPauses = generalDuration - pauseDuration * (countOfScenes - 1);
        const oneSceneDuration = durationWithoutPauses / countOfScenes;

        const secondSceneStartPosition = oneSceneDuration + pauseDuration;
        const thirdSceneStartPosition = secondSceneStartPosition + oneSceneDuration + pauseDuration;
        const fourthSceneStartPosition = thirdSceneStartPosition + oneSceneDuration + pauseDuration;
        const fifthSceneStartPosition = fourthSceneStartPosition + oneSceneDuration + pauseDuration;

        export const Scroll = {
            transitions: [
                t(States.Root.root_rotate, 'Base State', 'State', st(oneSceneDuration, 0, true)),
                t(States.Music.root, 'Base State', 'State', st(oneSceneDuration, 0, true)),
                t(States.Curator.root, 'Base State', 'State', st(oneSceneDuration, 0, true)),

                t(States.Root.root_rotate, 'State', 'State 2', st(oneSceneDuration, secondSceneStartPosition)),
                t(States.Curator.root, 'State', 'Base State', st(oneSceneDuration, secondSceneStartPosition)),
                t(States.Quality.root, 'Base State', 'State', st(oneSceneDuration, secondSceneStartPosition, true)),

                t(States.Root.root_rotate, 'State 2', 'State 3', st(oneSceneDuration, thirdSceneStartPosition)),
                t(States.Quality.root, 'State', 'Base State', st(oneSceneDuration, thirdSceneStartPosition)),
                t(States.Optimize.root, 'Base State', 'State', st(oneSceneDuration, thirdSceneStartPosition, true)),

                t(States.Root.root_rotate, 'State 3', 'State 4', st(oneSceneDuration, fourthSceneStartPosition)),
                t(States.Optimize.root, 'State', 'Base State', st(oneSceneDuration, fourthSceneStartPosition)),
                t(States.Support.root, 'Base State', 'State', st(oneSceneDuration, fourthSceneStartPosition, true)),

                t(States.Root.root_rotate, 'State 4', 'State 5', st(oneSceneDuration, fifthSceneStartPosition)),
                t(States.Support.root, 'State', 'Base State', st(oneSceneDuration, fifthSceneStartPosition)),
                t(States.Dashboard.root, 'Base State', 'State', st(oneSceneDuration, fifthSceneStartPosition, true)),
            ],
        } as const satisfies AnimationEvent;

        const idleTransitionsParams = { duration: 3, easing: 'power1.inOut', position: 0, reset: true, cycle: true, loop: -1 } as const satisfies TransitionArgs;
        export const Idle = {
            transitions: [
                t(States.Root.root_float, 'Base State', 'State', { ...idleTransitionsParams }),

                // music
                t(States.Music.bar1, 'Base State', 'State', { ...idleTransitionsParams, delay: 1 }),
                t(States.Music.bar2, 'Base State', 'State', { ...idleTransitionsParams, delay: 1 }),
                t(States.Music.float, 'Base State', 'State', { ...idleTransitionsParams, duration: 2 }),

                // quality
                t(States.Quality.glass, 'Base State', 'State', { ...idleTransitionsParams, delay: 1 }),
                t(States.Quality.diamond, 'Base State', 'State', { ...idleTransitionsParams, delay: 1 }),
                t(States.Quality.icons1, 'Base State', 'State', { ...idleTransitionsParams, duration: 4, delay: 1 }),
                t(States.Quality.icons2, 'Base State', 'State', { ...idleTransitionsParams, duration: 4, delay: 1 }),

            ],
        } as const satisfies AnimationEvent;
    }
}
